module.exports = __webpack_public_path__ + "static/media/Asset 23@2x.b1cbe155.png";